$(document).ready(function () {
    $(".tabHeadingContainer").click(function () {
        $(".tabHeadingContainer").removeClass("activeTab");
        $(this).addClass("activeTab");
        var dataImgId = $(this).attr("data-id");
        $(".tabHeadingImgContainer").hide();
        $(dataImgId).fadeIn(500);
    });
    if ($('.mobile-menu__submenu').length > 0) {
        $('.mobile-menu__submenu .mega-menu').prepend(`
            <div class="megaMenuTop">
                
                <span class="closeMegaBtn"><svg xmlns="http://www.w3.org/2000/svg" width="12" height="24" viewBox="0 0 12 24" fill="none">
                <path d="M9.54801 17.42L8.48701 18.48L2.70801 12.703C2.61486 12.6104 2.54093 12.5004 2.49048 12.3791C2.44004 12.2579 2.41406 12.1278 2.41406 11.9965C2.41406 11.8652 2.44004 11.7351 2.49048 11.6139C2.54093 11.4926 2.61486 11.3826 2.70801 11.29L8.48702 5.51L9.54702 6.57L4.12301 11.995L9.54801 17.42Z" fill="#24272C"/>
                </svg> All</span>

                <span class="mobile-menu__close">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M18.36 19.78L12 13.41L5.63997 19.78L4.21997 18.36L10.59 12L4.21997 5.64L5.63997 4.22L12 10.59L18.36 4.23L19.77 5.64L13.41 12L19.77 18.36L18.36 19.78Z" fill="#24272C"/>
                </svg>
                </span>

            </div>
            `);
    }

   
    $("button.hamMenuBtn").click(function () {
        $("html").toggleClass("hideScroll");
        $("body").toggleClass("mobileMenuIsOpen");
        $(".mobile-header").toggleClass("isOpen");
    });

    $(".submenu__label span.close-dropdown").click(function () {
        // $("body").addClass("disabledMainMenuItems");
    });
    $('.mobile-menu__submenu .mega-menu .closeMegaBtn').on('click', function () {
        $('.submenu__input').prop('checked', false);
        // $("body").removeClass("disabledMainMenuItems");
    });

     if($(".dynamic-sections .under-menu").length < 1){
    $("body").addClass("whiteHeader");
  }

$(".menu__heading").click(function (e) {
    if ($(window).width() <= 1000) {
        
        var anchor = $(this).find('a');
        if (anchor.length && (anchor.attr('href') === '#' || anchor.attr('href') === '' || anchor.attr('href') === 'https://' || anchor.attr('href') === 'http://')) {
            e.preventDefault();
        }

        $(this).addClass("heading-open");
    }
});

// 2. Close the Menu when clicking the "All / Back" button
$(".mobile-menu-back-btn").click(function (e) {
    e.preventDefault();
    if ($(window).width() <= 1000) {
        // Finds the heading associated with this list and removes the open class to slide it back
        $(this).closest('.nested-mobile-menu').prev(".menu__heading").removeClass("heading-open");
    }
});

 $('.mobile-menu__close').on('click', function () {
    $('body').removeClass('mobileMenuIsOpen');
      $('html').removeClass('hideScroll');
  });

});

